<template>
  <h2 v-if="productName.length < 30">
    {{ productName }}
  </h2>
  <h2 v-else :title="productName">
    {{ productName.substr(0, 30) + "..." }}
  </h2>
</template>
<script>
export default {
  props: {
    productName: {
      type: String,
      required: true,
    },
  },
};
</script>
